import * as React from "react";

import Text from "/component/base/Text";
import { APP_SUPPORT_EMAIL } from "/constant/app.constant";
import { useTranslation } from "/hook";

import { Base, ContactUsLink } from "./ContactUs.styles";
import { Props } from "./ContactUs.types";

const ContactUs = ({ email, label, className }: Props) => {
  const { t } = useTranslation("partial-contactUs");

  return (
    <Base className={className}>
      <Text variant="body1" color="textSecondary">
        {label || t("title")}
      </Text>

      <ContactUsLink target="#" href={`mailto:${email || APP_SUPPORT_EMAIL}`}>
        <Text color="brandPrimary" variant="body1Bold">
          {t("contactUsText")}
        </Text>
      </ContactUsLink>
    </Base>
  );
};

export default ContactUs;
